import { createSelector } from '@reduxjs/toolkit';

import { getPromoInfos } from './getPromoInfos';
import { MORTGAGE_PROMO_TYPES } from '../../constants/newbuildingPromos';
import { IPromoInfo } from '../../types/newbuildingPromos';

const DEFAULT_PROMOS: IPromoInfo[] = [];

export const getNewbuildingPromos = createSelector([getPromoInfos], (promos: IPromoInfo[]): IPromoInfo[] => {
  if (!promos.length) {
    return DEFAULT_PROMOS;
  }

  return promos.filter(promo => !MORTGAGE_PROMO_TYPES.includes(promo.promoType));
});
